module.exports = __webpack_public_path__ + "img/iriomote_13.2a6643b9.jpg";